import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import Nav from "@/components/landing/Nav";
import Footer from "@/components/landing/Footer";
import StickyCta from "@/components/landing/StickyCta";
import HomePage from "@/pages/HomePage";
import QuizPage from "@/pages/QuizPage";
import DestinationPage from "@/pages/DestinationPage";
import LegalPage from "@/pages/LegalPage";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";

const ScrollReset = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <BrowserRouter>
            <div className="App min-h-screen bg-[#050505] pb-20 text-[#F5F5F0] md:pb-0">
                <div className="grain-overlay" aria-hidden="true" />
                <Nav />
                <ScrollReset />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/plan" element={<QuizPage />} />
                    <Route path="/blog" element={<BlogIndex />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                    <Route path="/destinations/:slug" element={<DestinationPage />} />
                    <Route path="/privacy-policy" element={<LegalPage docKey="privacy-policy" />} />
                    <Route path="/terms-and-conditions" element={<LegalPage docKey="terms-and-conditions" />} />
                    <Route path="/booking-policy" element={<LegalPage docKey="booking-policy" />} />
                </Routes>
                <Footer />
                <StickyCta />
                <Toaster position="top-center" theme="dark" />
            </div>
        </BrowserRouter>
    );
}

export default App;
